module.exports = __webpack_public_path__ + "img/icon.a109e4a4.png";